import CTLDate from "application/components/CTLDate";
import DefaultCell from "application/components/DefaultCell";
import { adminMenus } from "globals/configuration/admin";
import RowAction from "../backupRowAction";

const Attributes = {
  formSize: "md",
  enableBackupButton: true,
  enableUploadButton: true,
  enableRefresh: true,
  modes: adminMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const operationURLS = {
  list: "node-control/backups/system/configuration",
  createBackupDatabase: "node-control/backup/system/with-data",
  createBackupConfiguration: "node-control/backup/system/configuration",
  restoreConfiguration: "node-control/restore/system/configuration",
  delete: "node-control/backup/system/configuration",
  download: "node-control/backup/system/configuration/download",
};

const formatTimestamp = (timestamp) => {
  if (!timestamp) return "-";
  const [datePart, timePart] = timestamp.split("_");
  if (!datePart || !timePart) return timestamp;

  const year = datePart.substring(0, 4);
  const month = datePart.substring(4, 6);
  const day = datePart.substring(6, 8);
  const hour = timePart.substring(0, 2);
  const minute = timePart.substring(2, 4);
  const second = timePart.substring(4, 6);

  const dateObj = new Date(
    `${year}-${month}-${day}T${hour}:${minute}:${second}`
  );
  return dateObj
    .toLocaleString("en-GB", {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
    .replace(",", "");
};


const header = (onDelete, onRestore, onDownload) => [
  {
    name: "File Name",
    selector: (row) => row.filename,
    sortable: true,
    cell: (row) => <DefaultCell value={row.filename} />,
  },
  {
    name: "Created On",
    selector: (row) => row.timestamp,
    sortable: true,
    cell: (row) => <DefaultCell value={formatTimestamp(row.timestamp)} />,
  },
  {
    name: "Backup Type",
    selector: (row) => row.backupType,
    sortable: true,
    cell: (row) => <DefaultCell value={row.backupType} />,
  },
  {
    name: "Size KB",
    selector: (row) => row.size,
    sortable: true,
    cell: (row) => <DefaultCell value={row.size} />,
  },
  {
    name: "Size MB",
    selector: (row) => row.sizeMB,
    sortable: true,
    cell: (row) => <DefaultCell value={row.sizeMB} />,
  },
  {
    name: "Size GB",
    selector: (row) => row.sizeGB,
    sortable: true,
    cell: (row) => <DefaultCell value={row.sizeGB} />,
  },
  {
    name: "Last Modified",
    selector: (row) => row.lastModified,
    sortable: true,
    cell: (row) => <CTLDate value={row.lastModified} />,
  },
  {
    name: "Action",
    selector: (row) => row.path,
    sortable: false,
    cell: (row) => {
      return <RowAction row={row} onDelete={onDelete} onRestore={onRestore} onDownload={onDownload} />;
    },
  },
];

export { header, Attributes, operationURLS };
